import React from "react";
import { ModalStyled, ListStyled, ButtonStyled } from "./style";
import DefaultFileLink from "../CampanhasDefaultFileLink/defaultFileLink";
import { UseCampanhaContext } from "context/campanha-context";

const DefaultFileModal = () => {

    const {
        defaultFileModalOpen,
        setDefaultFileModalOpen
    } = UseCampanhaContext();

    return (
        <ModalStyled
            backdrop={true}
            show={defaultFileModalOpen}
            centered
            dialogClassName="modal-679"
            onHide={() => { setDefaultFileModalOpen(false) }}
        >
            <ModalStyled.Header>
                <ModalStyled.Title className="modal-title">
                    Aviso
                </ModalStyled.Title>
            </ModalStyled.Header>
            <ModalStyled.Body>
                <ListStyled>
                    <li>
                        O download do seu arquivo deve começar em breve, caso contrário,{' '}
                        <DefaultFileLink onModal>
                            <strong>clique aqui</strong>
                        </DefaultFileLink>;
                    </li>
                    <li>
                        Para preenchimento consultar as instruções;
                    </li>
                    <li>
                        Lembramos que para o envio dos contatos, é necessário que o arquivo esteja em <strong>.CSV</strong>.
                    </li>
                </ListStyled>

                <ButtonStyled onClick={() => setDefaultFileModalOpen(false)}>
                    Entendi
                </ButtonStyled>
            </ModalStyled.Body>
        </ModalStyled>
    )
}

export default DefaultFileModal;